/* eslint-disable no-param-reassign */
import produce from 'immer';

import { IS_OPEN } from '../actions/modalActions';


const initialState = {
  isOpen : false,
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_OPEN: {
      const {isOpen} = action.payload;
      return produce(state, (draft) => {
        draft.isOpen = isOpen;
      });
    }

    default: {
      return state;
    }
  }
};

export default modalReducer;
